export class AuthenticationError<R = unknown> extends Error {
  constructor(public data?: R) {
    super();
  }
}
